import { useRouter } from 'next/router'
import { useState } from 'react'

export default function Container({ children }) {
  const router = useRouter()
  const [isLoading, setIsLoading] = useState(false)
  const [defaultLink] = useState('/supercard')
  const [defaultBtnText] = useState('Get one now')

  const data = [
    {
      type: 'gold',
      isNew: false,
      link: defaultLink,
      bgImage: '/images/supercard_v2/gold-bg.png',
      midBgImage: '/images/supercard/sc-footer-gold.png',
      cardImg: '/images/supercard/v2/sc-gold.png',
      text: {
        card: 'Supercard Gold',
        cardColor: 'white',
        description:
          'Your SuperCard made more SUPER! Get more of what you love with upgraded perks and privileges.',
        descriptionColor: 'nobel'
      },
      mid: {
        bgColor: '#000000',
        titleColor: 'yellow-sea',
        descriptionColor: 'white',
        price: 'PHP 999.00'
      },
      btnText: defaultBtnText,
      url: '/supercard/get-one-now/supercard-gold'
    },
    {
      type: 'classic',
      isNew: false,
      link: defaultLink,
      bgImage: '/images/supercard/v2/classic-bg.svg',
      cardImg: '/images/supercard/v2/sc-classic.png',
      midBgImage: '/images/supercard/sc-footer-classic.png',
      text: {
        card: 'Supercard Classic',
        cardColor: 'black',
        description:
          'A must-have card for every wallet. Enjoy awesome benefits and deals all year long!',
        descriptionColor: 'black'
      },
      mid: {
        bgColor: '#FEB004',
        titleColor: 'red',
        descriptionColor: 'black',
        price: 'PHP 699.00'
      },
      btnText: defaultBtnText,
      url: '/supercard/get-one-now/supercard-classic'
    }
    // {
    //   type: 'plus',
    //   link: defaultLink,
    //   cardImg: '/images/supercard/sc-classic.png',
    //   bgImage: '/images/supercard/sc-bg-default.png',
    //   midBgImage: '/images/supercard/sc-footer-default.png',
    //   text: {
    //     card: 'Supercard',
    //     cardColor: 'black',
    //     description: 'Our old flame. You can still use and enjoy the perks until card expiry.',
    //     descriptionColor: 'black'
    //   },
    //   mid: {
    //     bgColor: '#FFFFFF',
    //     titleColor: 'red',
    //     descriptionColor: 'black',
    //     price: ''
    //   },
    //   btnText: 'View Details',
    //   url: '/supercard/compare'
    // }
  ]

  const redirectLink = (url) => {
    setIsLoading(true)
    router.push(url)
  }

  return children({ data, isLoading, setIsLoading, redirectLink })
}
